<div
    class="border-gray-200 fixed right-0 bottom-0 left-0 z-10 col-span-1 flex w-full bg-white md:relative md:block md:h-full">
    <div class="min-w-0 flex-1 md:hidden">
        <button
            type="button"
            aria-label="Toggle menu"
            [attr.aria-expanded]="(open$ | async) ? 'true' : 'false'"
            (click)="openSidebar()"
            class="fa-button flex w-full flex-col items-center p-4 px-2 text-black md:flex-row md:gap-4 md:p-8">
            <!-- Inline hamburger icon -->
            <svg
                class="h-5 md:h-6"
                viewBox="0 0 24 24"
                fill="none"
                xmlns="http://www.w3.org/2000/svg"
                aria-hidden="true">
                <path
                    d="M3 6h18M3 12h18M3 18h18"
                    stroke="currentColor"
                    stroke-width="2"
                    stroke-linecap="round" />
            </svg>
            <h4 class="pb-0 text-sm md:text-base">Menu</h4>
        </button>
    </div>
    <div class="min-w-0 flex-1 md:flex-none">
        <app-link
            link="/dashboard/trip-preparation"
            [routerLinkActive]="[
                'border-t md:border-r md:border-t-0 border-red md:border-b-0 md:bg-grey-150',
            ]"
            [additionalClasses]="[
                'flex w-full items-center md:gap-4 text-black p-4 px-2 md:p-8 flex-col md:flex-row',
            ]">
            <img
                class="h-5 md:block md:h-6"
                src="/assets/images/navigation/trip-prep-icon.svg"
                alt="trip preparation" />
            <h4 class="pb-0 text-center text-xs md:text-base">
                Trip preparation
            </h4>
        </app-link>
    </div>
    <div class="min-w-0 flex-1 md:flex-none">
        <app-link
            link="/dashboard/invoices"
            [routerLinkActive]="[
                'border-t md:border-r md:border-t-0 border-red md:border-b-0 md:bg-grey-150',
            ]"
            [additionalClasses]="[
                'flex w-full items-center md:gap-4 text-black p-4 px-2 md:p-8 flex-col md:flex-row',
            ]">
            <img
                class="h-5 md:block md:h-6"
                src="/assets/images/navigation/invoices-icon.svg"
                alt="invoice" />
            <h4 class="pb-0 text-center text-xs md:text-base">My Invoices</h4>
        </app-link>
    </div>
    <div class="min-w-0 flex-1 md:flex-none">
        <app-link
            link="/dashboard/credits"
            [routerLinkActive]="[
                'border-t md:border-r md:border-t-0 border-red md:border-b-0 md:bg-grey-150',
            ]"
            [additionalClasses]="[
                'flex w-full items-center md:gap-4 text-black p-4 px-2 md:p-8 flex-col md:flex-row',
            ]">
            <img
                class="h-5 md:block md:h-6"
                src="/assets/images/navigation/my-rewards-coin.png"
                alt="rewards" />
            <h4 class="pb-0 text-center text-xs md:text-base">My Rewards</h4>
        </app-link>
    </div>
    <div class="min-w-0 flex-1 md:flex-none">
        <app-link
            link="/dashboard/my-profile"
            [routerLinkActive]="[
                'border-t md:border-r md:border-t-0 border-red md:border-b-0 md:bg-grey-150',
            ]"
            [additionalClasses]="[
                'flex w-full items-center md:gap-4 text-black p-4 md:p-8 flex-col md:flex-row',
            ]">
            <img
                class="h-5 md:block md:h-6"
                src="/assets/images/navigation/my-profile-icon.svg"
                alt="profile" />
            <h4 class="pb-0 text-center text-xs md:text-base">My Profile</h4>
        </app-link>
    </div>
</div>
